import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ChevronRightIcon from "/public/images/icons/chevronRight.svg?react";

export default function BookingCard({ booking }) {
  const formattedDate = new Date(booking.dateSlot).toLocaleDateString("en-GB");
  const leadParticipant = booking.participants?.find((p) => p.isLeadParticipant);
  const totalParticipants = booking.participants?.length ?? 0;

  const isCancelled = booking.status === -1;

  return (
    <Link to={"/bookings/" + booking.bookingId} state={{ booking }} data-testid="booking-card-link">
      <div className="flex flex-row gap-y-4 border justify-between border-[#E3E3E3] rounded-lg p-6 bg-white">
        <div className="flex flex-col gap-y-2 p-4 justify-center">
          <p className="text-sportsYellow text-[12px] tracking-widest font-semibold">
            {formattedDate} <span>•</span> {booking.startTime?.slice(0, 5)}
          </p>
          {isCancelled && (
            <span className="text-[11px] font-semibold uppercase tracking-[1.5px] bg-red-100 text-red-600 rounded-[4px] px-[7px] py-[2px] w-fit">
              Cancelled
            </span>
          )}
          <p className="text-sportsDarkGrey text-[13px]">
            {booking.orgPartnerFriendlyName?.replace(/\b\w/g, c => c.toUpperCase())}
          </p>
          {booking.bookableThingName && (
            <p className="text-[24px] text-sportsBlack font-semibold">
              {booking.bookableThingName}
            </p>
          )}
          {booking.instanceName && (
            <p className="text-sportsDarkGrey text-[13px]">
              {booking.instanceCount} {booking.instanceName}
            </p>
          )}
          {leadParticipant && (
            <p className="text-sportsDarkGrey text-[13px]">
              {leadParticipant.participantName?.replace(/\b\w/g, c => c.toUpperCase())}
              {totalParticipants > 1 && (
                <span className="text-[11px] font-semibold uppercase tracking-[1.5px] bg-sportsLightGrey rounded-[4px] px-[7px] py-[2px] ml-2">
                  +{totalParticipants - 1} more
                </span>
              )}
            </p>
          )}
        </div>
        <div className="flex flex-col justify-center">
          <ChevronRightIcon className="w-6 h-6 fill-black" />
        </div>
      </div>
    </Link>
  );
}

BookingCard.propTypes = {
  booking: PropTypes.shape({
    bookingId: PropTypes.string.isRequired,
    dateSlot: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    orgPartnerFriendlyName: PropTypes.string.isRequired,
    bookableThingName: PropTypes.string,
    instanceName: PropTypes.string,
    instanceCount: PropTypes.number,
    participants: PropTypes.arrayOf(
      PropTypes.shape({
        participantName: PropTypes.string,
        isLeadParticipant: PropTypes.bool,
      })
    ),
  }).isRequired,
};
